var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useMemo } from "react";
import GenericDetails from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import LinkedSipCard from "./LinkedSipCard";
import TimelineStep from "./TimelineStep";
import { EMandateStatuses, EMandateTimelineStatuses, timelineStatusType, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import { convertStringToPascalCase } from "@frameworks/shared-library/utils/commonFunctions";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import OrderBookSideBarNeedHelp, { EContactDetailsFor, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBarNeedHelp";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { base64toPDFforceDownload } from "@frameworks/web/utils/base64_functions";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { Spinner } from "react-bootstrap";
import GenericTimeline, { ETimelineState, } from "@frameworks/shared-library/components/GenericTimeline/GenericTimeline";
import { accountDetails } from "@mainDi/salesDi";
var generateMandateSideBar = function (orderDetails, linkedSips) {
    var _a = __read(useState(false), 2), viewMore = _a[0], setViewMore = _a[1];
    var _b = __read(useState(false), 2), showDownloadLoader = _b[0], setShowDownloadLoader = _b[1];
    var handleOnClickDownloadForm = function () {
        setShowDownloadLoader(true);
        tocDi.mandate
            .downloadMandate({
            mandateId: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.mandateId,
            clientId: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.accCode,
            bankAccType: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.bankAccType,
        })
            .then(function (data) {
            var _a;
            if (((_a = data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                base64toPDFforceDownload(data.data, "mandateForm.pdf");
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () {
            setShowDownloadLoader(false);
        });
    };
    switch (orderDetails.dpStatus) {
        case EMandateStatuses.ACTIVE: {
            return (React.createElement(React.Fragment, null,
                React.createElement("header", { className: "status-header d-flex align-items-center justify-content-start" },
                    React.createElement("div", { className: "status-indicator d-flex align-items-center " },
                        React.createElement("div", { className: "status-dot bg-nuvama-green " }),
                        React.createElement("span", { className: "DMSansMedium_20_500 txt_nuvama-green" }, convertStringToPascalCase(orderDetails.dpStatus)))),
                linkedSips.length > 0 ? (React.createElement("main", { className: "order-details" },
                    React.createElement("div", { className: "main-section-active" },
                        React.createElement("h2", { className: "section-title DMsanL_12_300" }, "Linked SIPs"),
                        React.createElement("div", { className: "linked-sips-list d-flex flex-column" }, linkedSips === null || linkedSips === void 0 ? void 0 :
                            linkedSips.slice.apply(linkedSips, __spreadArray([], __read((viewMore ? [] : [0, 3])), false)).map(function (sip, index) { return (React.createElement(LinkedSipCard, __assign({ key: "".concat(index, "-").concat(sip.trxDateTime) }, sip))); }),
                            linkedSips.length > 3 && (React.createElement(EdButton, { btnTyp: "text-only", onClick: function () { return setViewMore(!viewMore); }, className: "DMSansNormal_12_400 txt-han-blue", value: React.createElement("span", { className: "d-flex align-items-center gap-1 justify-content-center" },
                                    React.createElement("span", { className: "text-decoration-underline" }, viewMore ? "View Less" : "View More"),
                                    React.createElement("i", { className: viewMore
                                            ? "edel-icon-arrow-up-thin"
                                            : "edel-icon-arrow-down" })) })))))) : null));
        }
        case EMandateStatuses.DOC_UPLOAD_PENDING:
        case EMandateStatuses.DOC_NOT_UPLOADED: {
            return (React.createElement(React.Fragment, null,
                React.createElement("header", { className: "status-header d-flex align-items-center justify-content-start" },
                    React.createElement("div", { className: "status-indicator d-flex align-items-center " },
                        React.createElement("div", { className: "status-dot bg_orange-shade" }),
                        React.createElement("span", { className: "DMSansMedium_20_500 txt_orange-shade" }, "Document Upload Pending"))),
                React.createElement("main", { className: "order-details" },
                    React.createElement("div", { className: "main-section-doc-upload-pending d-flex align-self-center flex-column w-100 justify-content-start" },
                        React.createElement(TimelineStep, { icon: "edel-icon-download-curve", title: "Download Mandate Form", actionButton: React.createElement(EdButton, { btnTyp: "text-only", onClick: handleOnClickDownloadForm, className: "download-btn txt-tomato cursor-pointer", value: React.createElement("div", { className: "d-flex align-items-center justify-content-between" }, showDownloadLoader ? (React.createElement(Spinner, { className: "download-spinner" })) : (React.createElement(React.Fragment, null, "Download Form"))) }) }),
                        React.createElement(TimelineStep, { icon: "edel-icon-download-curve", title: React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "w-100 d-flex flex-row gap-1 align-items-center" },
                                    React.createElement("label", { className: "DMSans_13_400 txt_blackOne1" }, "Send signed document to your CXO"),
                                    React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Send the signed document directly to your CXO for review or approval." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "edel-icon-Information txt_secondary-gray d-flex" }) }))) }),
                        React.createElement("div", { className: "order-date-time d-flex align-items-center" },
                            React.createElement("time", { className: "order-date Roboto_12_300 txt_whispering-periwinkle" }, "".concat((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.modifiedDate) || orderDetails.dpCreatedDate)))))));
        }
        case EMandateStatuses.PROCESSING: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        case EMandateStatuses.REGISTRATION_FAILED: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        case EMandateStatuses.INACTIVE: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        case EMandateStatuses.REGISTRATION_PENDING: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        case EMandateStatuses.WAITING_FOR_CLIENT_AUTHENTICATION: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        case EMandateStatuses.SCAN_IMAGE_NOT_UPLOADED: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        case EMandateStatuses.APPROVED: {
            return generateSimilarLayout(orderDetails.dpStatus, orderDetails.remarks, orderDetails.modifiedDate);
        }
        default:
            return React.createElement(React.Fragment, null);
    }
};
var generateSimilarLayout = function (status, statusMessage, modifiedDate) {
    var warningStatuses = [
        EMandateStatuses.DOC_UPLOAD_PENDING,
        EMandateStatuses.REGISTRATION_PENDING,
        EMandateStatuses.PROCESSING,
        EMandateStatuses.WAITING_FOR_CLIENT_AUTHENTICATION,
        EMandateStatuses.SCAN_IMAGE_NOT_UPLOADED,
        EMandateStatuses.APPROVED,
        EMandateStatuses.PROCESSING,
    ];
    var hasOrangeShade = warningStatuses.includes(status);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "status-header d-flex align-items-center justify-content-start" },
            React.createElement("div", { className: "status-indicator d-flex align-items-center " },
                React.createElement("div", { className: "status-dot ".concat(hasOrangeShade ? "bg_orange-shade" : "bg-tomato") }),
                React.createElement("span", { className: "DMSansMedium_20_500 ".concat(hasOrangeShade ? "txt_orange-shade" : "txt-tomato") }, convertStringToPascalCase(status)))),
        statusMessage && (React.createElement("div", { className: "status-message DMsanL_11_300 bg-sea-shell1 text-wrap" }, statusMessage)),
        modifiedDate && (React.createElement("div", { className: "order-date-time d-flex align-items-center" },
            React.createElement("time", { className: "order-date Roboto_12_300 txt_whispering-periwinkle" }, "".concat(modifiedDate))))));
};
var MandateOrderSideBarBody = function (props) {
    var orderDetails = props.orderDetails, genericDetailsProps = props.genericDetailsProps, linkedSips = props.linkedSips;
    var _a = __read(useState(false), 2), showTimelineDetails = _a[0], setShowTimelineDetails = _a[1];
    var _b = __read(useState([]), 2), timelineDetails = _b[0], setTimelineDetails = _b[1];
    var getMfTimelineDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var timelineData_1, _a, _b, details_1, err_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (props.orderDetails.dpStatus === EMandateStatuses.ACTIVE ||
                        props.orderDetails.dpStatus === EMandateStatuses.DOC_UPLOAD_PENDING)
                        return [2 /*return*/];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    _b = (_a = tocDi.mandate).mandateTimeline;
                    _c = {};
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 2: return [4 /*yield*/, _b.apply(_a, [(_c.loginType = _d.sent(),
                            _c.clientCode = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.accCode,
                            _c.mandateId = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.mandateId,
                            _c)])];
                case 3:
                    timelineData_1 = _d.sent();
                    details_1 = [];
                    timelineData_1.map(function (item, index) {
                        if (item.mandateStatus) {
                            var timelineStatus = index === timelineData_1.length - 1
                                ? timelineStatusType[item.mandateStatus]
                                : ETimelineState.COMPLETED;
                            details_1.push({
                                header: item.mandateStatus,
                                status: timelineStatus,
                                description: timelineStatus === ETimelineState.IN_PROGRESS
                                    ? "_"
                                    : item === null || item === void 0 ? void 0 : item.processDate,
                            });
                        }
                    });
                    if (props.orderDetails.dpStatus === EMandateStatuses.REGISTRATION_PENDING) {
                        details_1 = __spreadArray(__spreadArray([], __read(details_1), false), [
                            {
                                header: EMandateTimelineStatuses.REGISTRATION_COMPLETED,
                                status: ETimelineState.UNREACHED,
                                description: "_",
                            },
                        ], false);
                    }
                    if (props.orderDetails.dpStatus === EMandateStatuses.PROCESSING) {
                        details_1 = __spreadArray(__spreadArray([], __read(details_1), false), [
                            {
                                header: EMandateTimelineStatuses.VERIFICATION_COMPLETED,
                                status: ETimelineState.UNREACHED,
                                description: "_",
                            },
                        ], false);
                    }
                    if (props.orderDetails.dpStatus === EMandateStatuses.DOC_NOT_UPLOADED) {
                        details_1 = __spreadArray(__spreadArray([], __read(details_1), false), [
                            {
                                header: EMandateTimelineStatuses.DOCUMENT_UPLOADED,
                                status: ETimelineState.UNREACHED,
                                description: "_",
                            },
                        ], false);
                    }
                    setTimelineDetails(details_1);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _d.sent();
                    console.log(err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var toggleShowOrderTimeline = function () {
        setShowTimelineDetails(function (prev) { return !prev; });
    };
    useEffect(function () {
        getMfTimelineDetails();
    }, []);
    var showTimeline = useMemo(function () {
        var dpStatus = props.orderDetails.dpStatus;
        return ![
            EMandateStatuses.ACTIVE,
            EMandateStatuses.DOC_NOT_UPLOADED,
        ].includes(dpStatus);
    }, [props.orderDetails.dpStatus]);
    return (React.createElement("div", { className: "bg_aqua_whites primary-order-book-mandate-sidebar-body d-flex flex-column justify-content-between ".concat(orderDetails.dpStatus === EMandateStatuses.ACTIVE ||
            orderDetails.dpStatus === EMandateStatuses.REGISTRATION_FAILED
            ? "reduced__height__with__footer"
            : "") },
        React.createElement("div", null,
            React.createElement("div", { className: "order-book-sidebar-body-top ".concat(showTimelineDetails
                    ? "reduced__bottom__padding__with__timeline"
                    : "") },
                React.createElement("section", { className: "order-status" },
                    generateMandateSideBar(orderDetails, linkedSips),
                    showTimeline && (React.createElement("div", { className: "mx-3 mt-3" },
                        React.createElement("div", { className: "hand_cursor", onClick: toggleShowOrderTimeline },
                            React.createElement("span", { className: "DMSansNormal_12_400 text-decoration-underline txt-midnight-blue" }, "Order Timeline"),
                            React.createElement(EdButton, { btnTyp: "text-only", className: "DMSansNormal_12_400 mx-1", value: React.createElement("span", { className: "d-flex align-items-center gap-1 justify-content-center" },
                                    React.createElement("i", { className: showTimelineDetails
                                            ? "edel-icon-arrow-up-thin"
                                            : "edel-icon-arrow-down" })) })),
                        showTimelineDetails && (React.createElement(GenericTimeline, { timelineDetails: timelineDetails, parentClassName: "p-0" })))))),
            React.createElement("div", { className: "order-book-sidebar-body-middle" },
                React.createElement(GenericDetails, { details: genericDetailsProps, header: "Other Info" }))),
        React.createElement("div", { className: "order-book-sidebar-body-bottom position-relative d-flex justify-content-between hand_cursor" },
            React.createElement("div", { className: "left-section d-flex align-items-center hand_cursor" },
                React.createElement(OrderBookSideBarNeedHelp, { clientCode: orderDetails.accCode, contactDetailsFor: EContactDetailsFor.helpDesk })))));
};
export default MandateOrderSideBarBody;
